import { defineStore } from "pinia";

export const useVideoStore = defineStore("videoStore", () => {
  const videoRefMap = ref({});
  // 记录上一个播放的视频key
  const preVideoKey = ref("");
  const setVideoRefToMap = (videoRef, key) => {
    if (videoRef && videoRefMap.value) {
      videoRefMap.value[key] = videoRef;
    }
  };
  const getVideoRefFromMap = (key) => {
    return videoRefMap.value[key];
  };
  const setPreVideoKey = (key) => {
    preVideoKey.value = key;
  };
  const getPreVideoKey = () => {
    return preVideoKey.value;
  };
  const getVideoIns = (key) => {
    return videoRefMap.value[key]
  };

  const handleAllVideo = (type, keys) => {
    const videoKeys = keys || Object.keys(videoRefMap.value);
    videoKeys.forEach((k) => {
      const ins = getVideoIns(k);      
      switch (type) {
        case "pause":
          ins?.pause?.();
          break;
        case "stop":
          ins?.seek?.(0);
          ins?.pause?.();
          break;
        default:
          break;
      }
    });
  };

  const playSingleVideo = (key, delay) => {
    const ins = getVideoIns(key)
    if (ins && ins.play) {
      if (!delay) {
        ins.play?.()
      } else {
        setTimeout(() => {
          console.log('延迟播放', key)
          ins.play?.()
        }, delay)
      }
    } else {
      setTimeout(() => {
        playSingleVideo(key)
      }, 500)
    }
  }

  const playWithPause = (
    key,
    delay = 500
  ) => {
    console.log('播放视频并pause', key,videoRefMap.value[key])
    const otherKeys = Object.keys(videoRefMap.value).filter((k) => k !== key);
    handleAllVideo('pause', otherKeys)
    key && playSingleVideo(key, delay)
  }

  const $reset = () => {
    videoRefMap.value = {};
    preVideoKey.value = "";
  };

  return {
    setVideoRefToMap,
    playWithPause,
    $reset
  };
});
